import moment from 'moment'
import { find } from 'lodash'

export default {
  computed: {
    placementStartComponentIsContextuallyNotOpen () {
      return this.placement.start_component_contextual_status === 'not_open'
    },

    placementStartComponentIsContextuallyOpen () {
      return this.placement.start_component_contextual_status === 'open'
    },

    placementStartComponentIsContextuallyOverdue () {
      return this.placement.start_component_contextual_status === 'overdue'
    },

    placementStartComponentIsPendingData () {
      return this.placement.start_component &&
        this.placement.start_component.status === null
    },

    placementStartComponentIsDraft () {
      return this.placement.start_component &&
        this.placement.start_component.status === 'draft'
    },

    placementStartComponentIsPendingReview () {
      return this.placement.start_component &&
        this.placement.start_component.status === 'review'
    },

    placementStartComponentIsSignedOff () {
      return this.placement.start_component &&
        this.placement.start_component.status === 'signed_off'
    },

    placementStartComponentIsLocked () {
      return this.placement.start_component &&
        this.placement.start_component.lock === true
    },

    placementStartComponentRequestAccessSent () {
      return this.placement.start_component &&
        this.placement.start_component.unlock_request_sent === true
    },

    placementStartComponentIsOpen () {
      return moment().isAfter(moment(this.placement.start_component_open_date))
    },

    placementEndComponentIsContextuallyNotOpen () {
      return this.placement.end_component_contextual_status === 'not_open'
    },

    placementEndComponentIsContextuallyOpen () {
      return this.placement.end_component_contextual_status === 'open'
    },

    placementEndComponentIsContextuallyOverdue () {
      return this.placement.end_component_contextual_status === 'overdue'
    },

    placementEndComponentIsPendingData () {
      return this.placement.end_component &&
        this.placement.end_component.status === null
    },

    placementEndComponentIsDraft () {
      return this.placement.end_component &&
        this.placement.end_component.status === 'draft'
    },

    placementEndComponentIsPendingReview () {
      return this.placement.end_component &&
        this.placement.end_component.status === 'review'
    },

    placementEndComponentIsSignedOff () {
      return this.placement.end_component &&
        this.placement.end_component.status === 'signed_off'
    },

    placementEndComponentIsOpen () {
      return moment().isAfter(moment(this.placement.end_component_open_date))
    },

    placementEndComponentGraduateCommentsSubmitted () {
      return this.placement.end_component &&
        this.placement.end_component.graduate_comments_submitted === true
    },

    placementEndComponentCapabilityAssessmentComplete () {
      return this.placement.end_component &&
        this.placement.end_component.capability_assessment_completed === true
    },

    placementEndComponentPerformanceObjectivesComplete () {
      return this.placement.end_component &&
        this.placement.end_component.performance_objectives_completed === true
    },

    placementEndComponentOverallAssessmentComplete () {
      return this.placement.end_component &&
        this.placement.end_component.overall_assessment_completed === true
    },

    placementIsFinalised () {
      return this.placement.finalised === true
    },

    placementIsNotFinalised () {
      return this.placement.finalised === false
    },

    placementHasACoordinatorsAgency () {
      let foundAgency = find(this.$user.agencies, (agency) => {
        return agency.id === this.placement.agency_id
      })

      return this.$userIsCoordinator && foundAgency !== undefined
    }
  }
}
